(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[365],{

/***/ 79429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addYears; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/***/ }),

/***/ 28789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ 99982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUnixTime; }
/* harmony export */ });
/* harmony import */ var _getTime_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28789);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */

function getUnixTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return Math.floor((0,_getTime_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate) / 1000);
}

/***/ }),

/***/ 73061:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 70255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jr": function() { return /* binding */ useBaseFeePerGasStats; },
  "nv": function() { return /* binding */ useBaseFeePerGasStatsTimeFrame; },
  "BZ": function() { return /* binding */ useBlobBaseFeeStats; }
});

// UNUSED EXPORTS: fetchBaseFeePerGasStats, fetchBaseFeePerGasStatsTimeFrame

// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js
var secondsToMilliseconds = __webpack_require__(62523);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/minutesToMilliseconds/index.js


/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */

function minutesToMilliseconds(minutes) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(minutes * constants/* millisecondsInMinute */.yJ);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/hoursToMilliseconds/index.js


/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted to milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */

function hoursToMilliseconds(hours) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(hours * constants/* millisecondsInHour */.vh);
}
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/base-fee-per-gas-stats.ts




const url = "/api/v2/fees/base-fee-per-gas-stats";
const blob_url = "/api/v2/fees/blob-fee-per-gas-stats";
const fetchBaseFeePerGasStats = ()=>fetchApiJson(url);
const useBlobBaseFeeStats = ()=>{
    const { data  } = (0,dist/* default */.ZP)(blob_url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    });
    return data;
};
const useBaseFeePerGasStats = ()=>{
    const { data  } = (0,dist/* default */.ZP)(url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    });
    return data;
};
const fetchBaseFeePerGasStatsTimeFrame = (timeFrame)=>fetchApiJson("".concat(url, "?time_frame=").concat(timeFrame));
const refreshIntervalMap = {
    m5: (0,secondsToMilliseconds/* default */.Z)(4),
    h1: (0,secondsToMilliseconds/* default */.Z)(4),
    d1: minutesToMilliseconds(1),
    d7: minutesToMilliseconds(10),
    d30: hoursToMilliseconds(1),
    since_burn: hoursToMilliseconds(1),
    since_merge: hoursToMilliseconds(1)
};
const useBaseFeePerGasStatsTimeFrame = function(timeFrame) {
    let blobFees = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const fullUrl = "".concat(blobFees ? blob_url : url, "?time_frame=").concat(timeFrame);
    if (blobFees) {
        console.log("Requesting blob fees over time:", fullUrl);
    }
    const { data  } = (0,dist/* default */.ZP)(fullUrl, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: refreshIntervalMap[timeFrame]
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 97355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useSupplyProjectionInputs; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);


const useSupplyProjectionInputs = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("/api/v2/fees/supply-projection-inputs", _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar);
    return data;
};


/***/ }),

/***/ 82038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Slider2_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50421);
/* harmony import */ var _Slider2_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Slider2_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const Slider = (param)=>/*#__PURE__*/ {
    let { max , min , onChange , step , thumbVisible =true , value  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        className: "\n      absolute\n      z-10\n      my-1 h-2 w-full\n      cursor-pointer\n      appearance-none\n      rounded-full\n      bg-slateus-600\n      ".concat(thumbVisible ? "" : (_Slider2_module_scss__WEBPACK_IMPORTED_MODULE_1___default().thumbInvisible), "\n      ").concat((_Slider2_module_scss__WEBPACK_IMPORTED_MODULE_1___default().customSlider), "\n    "),
        type: "range",
        min: min,
        max: max,
        value: value,
        onChange: onChange,
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Slider);


/***/ }),

/***/ 64365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_SupplyProjectionsSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  return month;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js
var getUnixTime = __webpack_require__(99982);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js + 1 modules
var addYears = __webpack_require__(79429);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var lodash_last = __webpack_require__(73061);
var last_default = /*#__PURE__*/__webpack_require__.n(lodash_last);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/components/TextsNext/BodyText.tsx
var BodyText = __webpack_require__(68539);
// EXTERNAL MODULE: ./src/components/Twemoji.tsx
var Twemoji = __webpack_require__(63365);
;// CONCATENATED MODULE: ./src/components/SliderMarkers.tsx



// Minimum percentage difference between markers to avoid overlap
const MIN_PERCENTAGE_DIFFERENCE = 5;
const SliderMarkers = (param)=>{
    let { markerList , min , max  } = param;
    const range = max - min;
    const shownList = markerList.reduce((list, marker)=>{
        const someConflict = list.some((shownMarker)=>Math.abs(shownMarker.value - marker.value) < (max - min) * MIN_PERCENTAGE_DIFFERENCE / 100);
        if (someConflict) {
            return list;
        }
        return [
            ...list,
            marker
        ];
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shownList.map((marker, index)=>{
            const percent = (marker.value - min) / range * 100;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n              absolute top-[14px] flex\n              -translate-x-1/2 flex-col items-center\n            ",
                // Positions the marker along the track whilst compensating for the thumb width as the browser natively does. 7 being half the thumb width.
                style: {
                    left: "calc(".concat(percent, "% - ").concat((percent / 100 * 2 - 1) * 7, "px)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "\n                -mt-0.5 w-0.5 rounded-b-full bg-slateus-200\n                ".concat(index % 2 === 0 ? "h-2" : "h-6", "\n              ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* TimeFrameText */.Z2, {
                        className: "mt-1 select-none text-slateus-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twemoji/* default */.Z, {
                            className: "flex gap-x-1",
                            imageClassName: "mt-0.5 h-3",
                            wrapper: true,
                            children: marker.label
                        })
                    })
                ]
            }, marker.label);
        })
    });
};
/* harmony default export */ var components_SliderMarkers = (SliderMarkers);

// EXTERNAL MODULE: ./src/components/WidgetErrorBoundary.tsx + 1 modules
var WidgetErrorBoundary = __webpack_require__(46400);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./src/eth-units.ts
var eth_units = __webpack_require__(41492);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js
var secondsToMilliseconds = __webpack_require__(62523);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/burn-rates.ts




const url = "/api/v2/fees/burn-rates";
const fetchBurnRates = ()=>fetchApiJson(url);
const useBurnRates = ()=>{
    const { data  } = (0,dist/* default */.ZP)(url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};

;// CONCATENATED MODULE: ./src/mainsite/api/effective-balance-sum.ts


const useEffectiveBalanceSum = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/v2/fees/effective-balance-sum", fetchers/* fetchJsonSwr */.Ar);
    return data;
};

// EXTERNAL MODULE: ./src/mainsite/api/supply-parts.ts
var supply_parts = __webpack_require__(43919);
// EXTERNAL MODULE: ./src/mainsite/api/supply-projection.ts
var supply_projection = __webpack_require__(97355);
// EXTERNAL MODULE: ./src/mainsite/components/Amount.tsx
var Amount = __webpack_require__(30772);
// EXTERNAL MODULE: ./src/mainsite/components/Slider2.tsx
var Slider2 = __webpack_require__(82038);
;// CONCATENATED MODULE: ./src/mainsite/components/EquilibriumWidget/index.tsx


















const EquilibriumGraph = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(344), __webpack_require__.e(328)]).then(__webpack_require__.bind(__webpack_require__, 3328)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3328)
            ]
    }
});
const MINUTES_PER_YEAR = 365.25 * 24 * 60;
const burnAsFraction = (nonStakingSupply, ethBurnPerMinute)=>ethBurnPerMinute * MINUTES_PER_YEAR / nonStakingSupply;
const MAX_EFFECTIVE_BALANCE = 32 * eth_units/* GWEI_PER_ETH */.rn;
const SECONDS_PER_SLOT = 12;
const SLOTS_PER_EPOCH = 32;
const EPOCHS_PER_DAY = 24 * 60 * 60 / SLOTS_PER_EPOCH / SECONDS_PER_SLOT;
const EPOCHS_PER_YEAR = 365.25 * EPOCHS_PER_DAY;
const BASE_REWARD_FACTOR = 64;
const getIssuancePerYear = (effective_balance_sum)=>{
    const balance_sum_gwei = effective_balance_sum * eth_units/* GWEI_PER_ETH */.rn;
    const max_issuance_per_epoch = Math.trunc(BASE_REWARD_FACTOR * balance_sum_gwei / Math.floor(Math.sqrt(balance_sum_gwei)));
    const issuancePerYear = max_issuance_per_epoch * EPOCHS_PER_YEAR;
    return issuancePerYear / eth_units/* GWEI_PER_ETH */.rn;
};
const getIssuanceApr = (effective_balance_sum)=>{
    const balance_sum_gwei = effective_balance_sum;
    const max_issuance_per_epoch = Math.trunc(BASE_REWARD_FACTOR * balance_sum_gwei / Math.floor(Math.sqrt(balance_sum_gwei)));
    const issuancePerYear = max_issuance_per_epoch * EPOCHS_PER_YEAR;
    const apr = issuancePerYear / balance_sum_gwei;
    return apr;
};
const BASE_REWARDS_PER_EPOCH = 4;
const getStakedFromApr = (apr)=>{
    const baseReward = apr * 32e9 / 4 / EPOCHS_PER_YEAR;
    const active_validators = (MAX_EFFECTIVE_BALANCE * BASE_REWARD_FACTOR / BASE_REWARDS_PER_EPOCH / baseReward) ** 2 / 32e9;
    return active_validators * 32;
};
const getBurn = (yearlyNonStakedBurnFraction, nonStakedSupply)=>yearlyNonStakedBurnFraction * nonStakedSupply;
const STAKING_MIN = 0.025;
const STAKING_MAX = 0.035;
const STAKING_RANGE = STAKING_MAX - STAKING_MIN;
const BURN_RATE_MIN = 0.0;
const BURN_RATE_MAX = 0.03;
const BurnMarkers = (param)=>{
    let { burnMarkers  } = param;
    const markerList = burnMarkers !== undefined ? [
        {
            label: "all",
            value: burnMarkers.all
        },
        {
            label: "\uD83E\uDD87\uD83D\uDD0A\uD83D\uDEA7",
            value: burnMarkers.ultrasound
        },
        {
            label: "30d",
            value: burnMarkers.d30
        },
        {
            label: "7d",
            value: burnMarkers.d7
        },
        {
            label: "1d",
            value: burnMarkers.d1
        }
    ] : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SliderMarkers, {
        markerList: markerList,
        min: BURN_RATE_MIN,
        max: BURN_RATE_MAX
    });
};
const supplyColorClass = (equilibriumSupply, ethSupply)=>{
    if (equilibriumSupply === undefined || ethSupply === undefined) {
        return undefined;
    }
    const baseClass = "text-transparent bg-gradient-to-r bg-clip-text";
    const colorClass = equilibriumSupply < ethSupply ? "from-orange-400 to-yellow-300" : "from-cyan-300 to-indigo-500";
    return "".concat(baseClass, " ").concat(colorClass);
};
const EquilibriumWidget = ()=>{
    const burnRates = useBurnRates();
    const supplyProjectionInputs = (0,supply_projection/* useSupplyProjectionInputs */.k)();
    const ethSupply = (0,supply_parts/* useImpreciseEthSupply */.gC)();
    const effectiveBalanceSum = useEffectiveBalanceSum();
    const [initialEquilibriumInputsSet, setInitialEquilibriumInputsSet] = (0,react.useState)(false);
    const [stakingAprFraction, setStakingAprFraction] = (0,react.useState)(0);
    const [nonStakingBurnFraction, setNonStakingBurnFraction] = (0,react.useState)(0);
    const [nowMarker, setNowMarker] = (0,react.useState)();
    const [burnMarkers, setBurnMarkers] = (0,react.useState)();
    // Only runs once because of initialEquilibriumInputsSet, after data loads.
    (0,react.useEffect)(()=>{
        if (burnRates === undefined || ethSupply === undefined || effectiveBalanceSum === undefined || initialEquilibriumInputsSet) {
            return;
        }
        const initialStakingApr = getIssuanceApr(effectiveBalanceSum.sum);
        const staked = effectiveBalanceSum.sum / 1e9;
        const nonStakedSupply = ethSupply - staked;
        setInitialEquilibriumInputsSet(true);
        setStakingAprFraction(initialStakingApr);
        setNowMarker(initialStakingApr);
        setNonStakingBurnFraction(burnAsFraction(nonStakedSupply, burnRates.since_burn.rate.eth_per_minute));
        // Ugly fix, clamp the staking apr to the range of the slider. Max only.
        // Burn rate can't go below zero. Consider composing something with the
        // overlap filter that happens in BurnMarkers.
        // It'd be nice to visually indicate a marker has broken the max.
        const clampBurnRateAsFraction = (value)=>Math.min(value, BURN_RATE_MAX);
        setBurnMarkers({
            // Let's be _really_ optimistic here. We probably don't have to clamp this.
            all: clampBurnRateAsFraction(burnAsFraction(nonStakedSupply, burnRates.since_burn.rate.eth_per_minute)),
            d1: clampBurnRateAsFraction(burnAsFraction(nonStakedSupply, burnRates.d1.rate.eth_per_minute)),
            d30: clampBurnRateAsFraction(burnAsFraction(nonStakedSupply, burnRates.d30.rate.eth_per_minute)),
            d7: clampBurnRateAsFraction(burnAsFraction(nonStakedSupply, burnRates.d7.rate.eth_per_minute)),
            ultrasound: getIssuancePerYear(staked) / nonStakedSupply
        });
    }, [
        burnRates,
        effectiveBalanceSum,
        ethSupply,
        initialEquilibriumInputsSet,
        stakingAprFraction
    ]);
    (0,react.useEffect)(()=>{
        if (burnRates === undefined || effectiveBalanceSum === undefined || ethSupply === undefined) {
            return;
        }
        const issuancePerYear = getIssuancePerYear(getStakedFromApr(stakingAprFraction));
        const nonStakedSupply = ethSupply - getStakedFromApr(stakingAprFraction);
        setBurnMarkers((burnMarkers)=>burnMarkers !== undefined ? {
                ...burnMarkers,
                ultrasound: issuancePerYear / nonStakedSupply
            } : undefined);
    }, [
        burnRates,
        effectiveBalanceSum,
        ethSupply,
        stakingAprFraction
    ]);
    const historicSupplyByMonth = (0,react.useMemo)(()=>{
        if (supplyProjectionInputs === undefined) {
            return undefined;
        }
        const list = supplyProjectionInputs.supplyByDay.reduce((list, point)=>{
            const last = last_default()(list);
            // First loop there is no last to compare to.
            if (last === undefined) {
                return [
                    [
                        point.t,
                        point.v
                    ]
                ];
            }
            // If we don't have a point from this month yet, add it.
            if (getMonth(fromUnixTime/* default */.Z(last[0])) !== getMonth(fromUnixTime/* default */.Z(point.t))) {
                return [
                    ...list,
                    [
                        point.t,
                        point.v
                    ]
                ];
            }
            // If we already have a point from a given month, don't add another.
            return list;
        }, []);
        return list;
    }, [
        supplyProjectionInputs
    ]);
    const equilibriums = (0,react.useMemo)(()=>{
        if (stakingAprFraction === undefined || nonStakingBurnFraction === undefined || historicSupplyByMonth === undefined || ethSupply === undefined) {
            return undefined;
        }
        const supplyEquilibriumSeries = [
            ...historicSupplyByMonth
        ];
        // Now calculate n years into the future to paint an equilibrium.
        let supply = [
            getUnixTime/* default */.Z(startOfDay/* default */.Z(new Date())),
            ethSupply
        ];
        const staked = getStakedFromApr(stakingAprFraction);
        let nonStaked = supply[1] - staked;
        const issuance = getIssuancePerYear(staked);
        const YEARS_TO_SIMULATE = 200;
        for(let i = 0; i < YEARS_TO_SIMULATE; i++){
            const yearDateTime = fromUnixTime/* default */.Z(supply[0]);
            const nextYear = getUnixTime/* default */.Z(addYears/* default */.Z(yearDateTime, 1));
            const burn = getBurn(nonStakingBurnFraction, nonStaked);
            const nextSupply = supply[1] + issuance - burn;
            supply = [
                nextYear,
                nextSupply
            ];
            supplyEquilibriumSeries.push(supply);
            nonStaked = supply[1] - staked;
        }
        const supplyEquilibriumMap = supplyEquilibriumSeries.reduce((map, param)=>{
            let [t, v] = param;
            map[t] = v;
            return map;
        }, {});
        const supplyEquilibrium = getIssuancePerYear(staked) / nonStakingBurnFraction + staked;
        const nonStakedSupplyEquilibrium = nonStaked;
        const cashFlowsEquilibrium = getIssuancePerYear(staked);
        const yearlyIssuanceFraction = getIssuanceApr(staked) / staked;
        return {
            cashFlowsEquilibrium,
            nonStakedSupplyEquilibrium,
            supplyEquilibrium,
            supplyEquilibriumMap,
            supplyEquilibriumSeries,
            yearlyIssuanceFraction
        };
    }, [
        stakingAprFraction,
        nonStakingBurnFraction,
        historicSupplyByMonth,
        ethSupply
    ]);
    const nowMarkerPercent = nowMarker !== undefined ? (nowMarker - STAKING_MIN) / STAKING_RANGE * 100 : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetErrorBoundary/* default */.Z, {
        title: "supply equilibrium",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
            className: "relative flex-col gap-x-4 overflow-hidden p-0 lg:flex-row-reverse",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    // will-change-transform is critical for mobile performance of rendering the chart overlayed on this element.
                    className: "\n            pointer-events-none absolute top-0\n            right-0 h-full\n            w-3/5\n            opacity-[0.25]\n            blur-[100px]\n            will-change-transform\n          ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "\n              pointer-events-none absolute h-3/5\n              w-4/5 rounded-[35%] bg-[#0037FA]\n              lg:bottom-[3.0rem]\n              lg:-right-[1.0rem]\n            "
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 gap-x-8 gap-y-8 p-8 lg:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            className: "hidden md:inline",
                                            children: "supply equilibrium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            className: "inline md:hidden",
                                            children: "equilibrium (A)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* MoneyAmount */.qn, {
                                            amountPostfix: nonStakingBurnFraction === 0 ? "" : "M",
                                            className: supplyColorClass(equilibriums === null || equilibriums === void 0 ? void 0 : equilibriums.supplyEquilibrium, ethSupply),
                                            textSizeClass: "text-2xl md:text-3xl",
                                            children: equilibriums !== undefined ? format/* formatOneDecimal */.F9(equilibriums.supplyEquilibrium / 1e6) : undefined
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            className: "hidden text-right md:inline",
                                            children: "staking"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            className: "inline text-right md:hidden",
                                            children: "staking (B)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* MoneyAmount */.qn, {
                                            amountPostfix: "M",
                                            unitText: "ETH",
                                            textSizeClass: "text-2xl md:text-3xl",
                                            children: stakingAprFraction !== undefined && initialEquilibriumInputsSet ? format/* formatOneDecimal */.F9(getStakedFromApr(stakingAprFraction) / 1e6) : undefined
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row-span-3 lg:col-start-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    className: "lg:ml-6",
                                    children: "ETH supply—200y projection"
                                }),
                                equilibriums !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EquilibriumGraph, {
                                    supplyEquilibriumSeries: equilibriums.supplyEquilibriumSeries,
                                    supplyEquilibriumMap: equilibriums.supplyEquilibriumMap,
                                    supplyEquilibrium: equilibriums.supplyEquilibrium,
                                    staking: getStakedFromApr(stakingAprFraction)
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-y-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-baseline justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center truncate",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                                            children: "issuance rewards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                                            className: "invisible text-xs md:text-xs lg:visible",
                                                            children: "\xa0for stakers"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* PercentAmount */.p7, {
                                                    amountPostfix: "/year",
                                                    className: "text-base lg:text-lg",
                                                    children: stakingAprFraction !== undefined && initialEquilibriumInputsSet ? format/* formatPercentOneDecimal */.B_(stakingAprFraction) : undefined
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative z-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider2/* default */.Z, {
                                                    min: STAKING_MIN,
                                                    max: STAKING_MAX,
                                                    value: stakingAprFraction,
                                                    step: 0.001,
                                                    onChange: (event)=>setStakingAprFraction(Number(event.target.value)),
                                                    thumbVisible: initialEquilibriumInputsSet
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "\n                  relative top-[14px] flex\n                  -translate-x-1/2 select-none flex-col\n                  items-center\n                  ".concat(nowMarkerPercent === undefined ? "invisible" : "visible", "\n                "),
                                                    style: {
                                                        // Positions the marker along the track whilst compensating for the thumb width as the browser natively does. 7 being half the thumb width.
                                                        left: "calc(".concat(nowMarkerPercent, "% - ").concat(((nowMarkerPercent !== null && nowMarkerPercent !== void 0 ? nowMarkerPercent : 0) / 100 * 2 - 1) * 7, "px)")
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "-mt-0.5 h-2 w-0.5 rounded-b-full bg-slateus-200"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* TimeFrameText */.Z2, {
                                                            className: "mt-0.5 text-slateus-200",
                                                            children: "now"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-baseline justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center truncate",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                                            children: "burn rate"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                                            className: "text-xs md:text-xs",
                                                            children: "\xa0for non-stakers"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* PercentAmount */.p7, {
                                                    amountPostfix: "/year",
                                                    children: nonStakingBurnFraction !== undefined && initialEquilibriumInputsSet ? format/* formatPercentOneDecimal */.B_(nonStakingBurnFraction) : undefined
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative mb-10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider2/* default */.Z, {
                                                    min: BURN_RATE_MIN,
                                                    max: BURN_RATE_MAX,
                                                    value: nonStakingBurnFraction,
                                                    step: 0.001,
                                                    onChange: (event)=>setNonStakingBurnFraction(Number(event.target.value)),
                                                    thumbVisible: initialEquilibriumInputsSet
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BurnMarkers, {
                                                    burnMarkers: burnMarkers
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-2 -mb-2 flex w-full flex-col items-baseline justify-between md:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "issuance and burn at equilibrium"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* MoneyAmount */.qn, {
                                    amountPostfix: "K",
                                    unitText: "ETH/year",
                                    children: equilibriums !== undefined ? format/* formatZeroDecimals */.UY(equilibriums.cashFlowsEquilibrium / 1e3) : undefined
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_EquilibriumWidget = (EquilibriumWidget);

// EXTERNAL MODULE: ./src/mainsite/contexts/TranslationsContext.ts + 1 modules
var TranslationsContext = __webpack_require__(146);
// EXTERNAL MODULE: ./src/mainsite/utils/metric-utils.ts
var metric_utils = __webpack_require__(90155);
// EXTERNAL MODULE: ./src/mainsite/components/Slider/Slider.module.scss
var Slider_module = __webpack_require__(21264);
var Slider_module_default = /*#__PURE__*/__webpack_require__.n(Slider_module);
;// CONCATENATED MODULE: ./src/mainsite/components/Slider/Slider.tsx



const THUMB_WIDTH = 14;
/**
 * The browser's native slider is difficult to style and leads
 * to very small tap targets on mobile, so instead we render a
 * transparent slider and use a custom UI in front of it.
 */ const Slider = (param)=>{
    let { min , max , onChange , onPointerDown , onPointerUp , step , thumbVisible =true , value  } = param;
    const percent = value !== undefined ? (value - min) / (max - min) * 100 : undefined;
    const offset = percent !== undefined ? Math.floor(percent * THUMB_WIDTH / 100) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Slider_module_default()).slider, " slider"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "range",
                min: min,
                max: max,
                value: value,
                step: step,
                onChange: onChange,
                className: "\n         ".concat((Slider_module_default()).sliderInput, "\n         ").concat(thumbVisible ? "" : (Slider_module_default()).thumbInvisible, "\n        "),
                onPointerDown: onPointerDown,
                onPointerUp: onPointerUp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Slider_module_default()).sliderTrack
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Slider_module_default()).sliderThumb,
                style: {
                    left: "calc(".concat(percent, "% - ").concat(offset, "px)")
                }
            })
        ]
    });
};
/* harmony default export */ var Slider_Slider = (Slider);

// EXTERNAL MODULE: ./src/mainsite/components/TwoYearProjection/TwoYearProjection.module.scss
var TwoYearProjection_module = __webpack_require__(42064);
var TwoYearProjection_module_default = /*#__PURE__*/__webpack_require__.n(TwoYearProjection_module);
// EXTERNAL MODULE: ./src/mainsite/api/base-fee-over-time.ts
var base_fee_over_time = __webpack_require__(40662);
// EXTERNAL MODULE: ./src/mainsite/api/base-fee-per-gas-stats.ts + 2 modules
var base_fee_per_gas_stats = __webpack_require__(70255);
;// CONCATENATED MODULE: ./src/mainsite/components/TwoYearProjection/index.tsx














const SupplyChart = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(111), __webpack_require__.e(337)]).then(__webpack_require__.bind(__webpack_require__, 71337)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(71337)
            ]
    }
});
const MIN_PROJECTED_ETH_STAKING = 1e6;
const DEFAULT_PROJECTED_ETH_STAKING = 30e6;
const MAX_PROJECTED_ETH_STAKING = 69696969;
const MIN_PROJECTED_BASE_GAS_PRICE = 0;
const DEFAULT_PROJECTED_BASE_GAS_PRICE = 60;
const MAX_PROJECTED_BASE_GAS_PRICE = 200;
const DEFAULT_PROJECTED_MERGE_DATE = new Date("2022-09-15T00:00:00Z");
const TwoYearProjection = ()=>{
    const t = (0,react.useContext)(TranslationsContext/* default */.Z);
    const [projectedStaking, setProjectedStaking] = (0,react.useState)(DEFAULT_PROJECTED_ETH_STAKING);
    const [projectedBaseGasPrice, setProjectedBaseGasPrice] = (0,react.useState)(DEFAULT_PROJECTED_BASE_GAS_PRICE);
    const [showBreakdown, setShowBreakdown] = (0,react.useState)(false);
    const [isPeakPresent, setIsPeakPresent] = (0,react.useState)(true);
    const handleProjectedStakingChange = (0,react.useCallback)((e)=>{
        setProjectedStaking(parseInt(e.target.value));
        setUserHasAdjustedStakedEth(true);
    }, []);
    const handleProjectedBaseGasPriceChange = (0,react.useCallback)((e)=>{
        setProjectedBaseGasPrice(parseInt(e.target.value));
        setUserHasAdjustedBaseFee(true);
    }, []);
    const projectedMergeDate = DEFAULT_PROJECTED_MERGE_DATE;
    const handleProjectedStakingPointerDown = (0,react.useCallback)(()=>{
        setShowBreakdown(true);
    }, []);
    const handleProjectedStakingPointerUp = (0,react.useCallback)(()=>{
        setShowBreakdown(false);
    }, []);
    const handleOnPeakProjectedToggle = (0,react.useCallback)((isPeakPresent)=>{
        setIsPeakPresent(isPeakPresent);
    }, []);
    const effectiveBalanceSum = useEffectiveBalanceSum();
    const baseFeesOverTime = (0,base_fee_over_time/* useBaseFeeOverTime */.Y)();
    const baseFeesPerGasStats = (0,base_fee_per_gas_stats/* useBaseFeePerGasStats */.Jr)();
    const [userHasAdjustedStakedEth, setUserHasAdjustedStakedEth] = (0,react.useState)(false);
    const [userHasAdjustedBaseFee, setUserHasAdjustedBaseFee] = (0,react.useState)(false);
    const [baseFeeSliderMarkers, setBaseFeeSliderMarkers] = (0,react.useState)([]);
    const [stakedEthSliderMarkers, setStakedEthSliderMarkers] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (effectiveBalanceSum === undefined || baseFeesOverTime === undefined) {
            return;
        }
        const intialStakingAmount = effectiveBalanceSum.sum / 1e9;
        setStakedEthSliderMarkers([
            {
                label: "now",
                value: intialStakingAmount
            }
        ]);
        if (!userHasAdjustedStakedEth) {
            setProjectedStaking(intialStakingAmount);
        }
        const latestBaseFee = baseFeesPerGasStats === null || baseFeesPerGasStats === void 0 ? void 0 : baseFeesPerGasStats.base_fee_per_gas_stats.m5.average;
        if (latestBaseFee === undefined || baseFeesPerGasStats === undefined) {
            return;
        }
        if (!userHasAdjustedBaseFee) {
            setProjectedBaseGasPrice((baseFeesPerGasStats === null || baseFeesPerGasStats === void 0 ? void 0 : baseFeesPerGasStats.base_fee_per_gas_stats.since_burn.average) / 1e9);
        }
        setBaseFeeSliderMarkers([
            {
                label: "now",
                value: latestBaseFee / 1e9
            },
            {
                label: "\uD83E\uDD87\uD83D\uDD0A\uD83D\uDEA7",
                value: baseFeesPerGasStats.barrier
            },
            {
                label: "all",
                value: baseFeesPerGasStats.base_fee_per_gas_stats.since_burn.average / 1e9
            },
            {
                label: "30d",
                value: baseFeesPerGasStats.base_fee_per_gas_stats.d30.average / 1e9
            },
            {
                label: "7d",
                value: baseFeesPerGasStats.base_fee_per_gas_stats.d7.average / 1e9
            },
            {
                label: "1d",
                value: baseFeesPerGasStats.base_fee_per_gas_stats.d1.average / 1e9
            }
        ]);
    }, [
        baseFeesOverTime,
        baseFeesPerGasStats,
        effectiveBalanceSum
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TwoYearProjection_module_default()).chartHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                    font: "font-inter",
                    className: "flex items-center px-3 pb-8 text-xs uppercase tracking-widest text-slateus-200",
                    inline: true,
                    children: [
                        "ETH supply—2y projection",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "transition-opacity ".concat(isPeakPresent ? "opacity-1" : "opacity-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twemoji/* default */.Z, {
                                className: "flex",
                                imageClassName: "inline ml-1 h-6",
                                wrapper: true,
                                children: "\uD83E\uDD87\uD83D\uDD0A"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyChart, {
                projectedStaking: projectedStaking,
                projectedBaseGasPrice: projectedBaseGasPrice,
                projectedMergeDate: projectedMergeDate,
                showBreakdown: showBreakdown,
                onPeakProjectedToggle: handleOnPeakProjectedToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TwoYearProjection_module_default()).params,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Param, {
                        title: t.eth_staked,
                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                Math.round(projectedStaking / 1e6),
                                t.numeric_million_abbrev,
                                " ETH"
                            ]
                        }),
                        subValue: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                t.pos_issuance,
                                ": ",
                                (0,format/* formatOneDecimal */.F9)((0,metric_utils/* estimatedDailyIssuance */.YG)(projectedStaking) / 1000),
                                "K ",
                                t.eth_per_day
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mb-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Slider, {
                                    min: MIN_PROJECTED_ETH_STAKING,
                                    max: MAX_PROJECTED_ETH_STAKING,
                                    value: projectedStaking,
                                    step: 1e6,
                                    onChange: handleProjectedStakingChange,
                                    onPointerDown: handleProjectedStakingPointerDown,
                                    onPointerUp: handleProjectedStakingPointerUp
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderMarkers, {
                                    markerList: stakedEthSliderMarkers,
                                    min: MIN_PROJECTED_ETH_STAKING,
                                    max: MAX_PROJECTED_ETH_STAKING
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Param, {
                        title: t.base_gas_price,
                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                Math.round(projectedBaseGasPrice),
                                " Gwei"
                            ]
                        }),
                        subValue: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                t.fee_burn,
                                ": ",
                                (0,format/* formatOneDecimal */.F9)((0,metric_utils/* estimatedDailyFeeBurn */.bw)(projectedBaseGasPrice) / 1000),
                                "K ",
                                t.eth_per_day
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mb-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_Slider, {
                                    min: MIN_PROJECTED_BASE_GAS_PRICE,
                                    max: MAX_PROJECTED_BASE_GAS_PRICE,
                                    value: projectedBaseGasPrice,
                                    step: 1,
                                    onChange: handleProjectedBaseGasPriceChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderMarkers, {
                                    markerList: baseFeeSliderMarkers,
                                    min: MIN_PROJECTED_BASE_GAS_PRICE,
                                    max: MAX_PROJECTED_BASE_GAS_PRICE
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const Param = (param)=>/*#__PURE__*/ {
    let { title , value , subValue , children  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (TwoYearProjection_module_default()).param,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-slateus-200 ".concat((TwoYearProjection_module_default()).paramTitle),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TwoYearProjection_module_default()).paramValue,
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TwoYearProjection_module_default()).paramChildren,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xs text-slateus-200 lg:text-base xl:text-lg ".concat((TwoYearProjection_module_default()).paramSubValue),
                children: subValue
            })
        ]
    });
};
/* harmony default export */ var components_TwoYearProjection = (TwoYearProjection);

// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(33040);
;// CONCATENATED MODULE: ./src/mainsite/sections/SupplyProjectionsSection.tsx




const SupplyProjectionsSection = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        title: "projections",
        subtitle: "ultra sound for decades to come",
        link: "projections",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EquilibriumWidget, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full rounded-xl bg-slateus-700 px-2 py-4 md:m-auto md:px-4 md:py-8 xl:px-12 xl:py-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TwoYearProjection, {})
                })
            ]
        })
    });
/* harmony default export */ var sections_SupplyProjectionsSection = (SupplyProjectionsSection);


/***/ }),

/***/ 90155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": function() { return /* binding */ estimatedDailyStakeChange; },
/* harmony export */   "YG": function() { return /* binding */ estimatedDailyIssuance; },
/* harmony export */   "bw": function() { return /* binding */ estimatedDailyFeeBurn; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export weiToGwei */
const SECONDS_PER_SLOT = 12;
const SLOTS_PER_EPOCH = 32;
const EPOCHS_PER_DAY = 24 * 60 * 60 / SLOTS_PER_EPOCH / SECONDS_PER_SLOT;
const BASE_REWARD_FACTOR = 64;
const GWEI_PER_ETH = 10 ** 9;
const MAX_ETH_PER_VALIDATOR = 32;
const MAX_EFFECTIVE_BALANCE = MAX_ETH_PER_VALIDATOR * GWEI_PER_ETH;
function integerSquareRoot(n) {
    return Math.floor(Math.sqrt(n));
}
function estimatedDailyIssuance(ethStaked) {
    const activeValidators = Math.floor(ethStaked / MAX_ETH_PER_VALIDATOR);
    const maxBalanceAtStake = activeValidators * MAX_EFFECTIVE_BALANCE;
    const MAX_ISSUANCE_PER_EPOCH = Math.floor(BASE_REWARD_FACTOR * maxBalanceAtStake / integerSquareRoot(maxBalanceAtStake));
    const MAX_ISSUANCE_PER_DAY = MAX_ISSUANCE_PER_EPOCH * EPOCHS_PER_DAY;
    return Math.floor(MAX_ISSUANCE_PER_DAY / GWEI_PER_ETH);
}
function estimatedDailyFeeBurn(baseGasPrice) {
    const gasLimit = 15000000;
    return SECONDS_PER_SLOT / 13 * // pre-merge block time is 13 seconds (conservative)
    (baseGasPrice * SLOTS_PER_EPOCH * EPOCHS_PER_DAY * gasLimit) / GWEI_PER_ETH;
}
function estimatedDailyStakeChange(ethStaked) {
    const validator_count = Math.floor(ethStaked / MAX_ETH_PER_VALIDATOR);
    const max_validator_churn_per_epoch = Math.max(4, Math.floor(validator_count / 65536));
    return max_validator_churn_per_epoch * MAX_ETH_PER_VALIDATOR * EPOCHS_PER_DAY;
}
function formatDate(date) {
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    return(// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    (date.getDate() < 10 ? " " : "") + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear());
}
const weiToGwei = (wei)=>wei / 10 ** 9;


/***/ }),

/***/ 21264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__lRE6d","sliderInput":"Slider_sliderInput__7Y6s2","thumbInvisible":"Slider_thumbInvisible__HBxak","sliderTrack":"Slider_sliderTrack__djsm2","sliderThumb":"Slider_sliderThumb___52sV"};

/***/ }),

/***/ 50421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSlider":"Slider2_customSlider__vsPiX","thumbInvisible":"Slider2_thumbInvisible__Fc__Q"};

/***/ }),

/***/ 42064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"chartHeader":"TwoYearProjection_chartHeader__UDBo1","params":"TwoYearProjection_params__KvK_k","param":"TwoYearProjection_param__rxRQk","paramTitle":"TwoYearProjection_paramTitle__Bzbi7","paramValue":"TwoYearProjection_paramValue__ZLLDd","paramSubValue":"TwoYearProjection_paramSubValue__bWMee","paramChildren":"TwoYearProjection_paramChildren__9XXgn"};

/***/ })

}]);